import { useDispatch } from "react-redux";
import Xarrow from "react-xarrows";
import { importFromYaml } from "../../../../abstract/controller/modelYamlImport";
import { useArrowSync } from "../../../../abstract/hook/useArrowSync";
import { setRoot } from "../../../../abstract/redux/slice/structureSlice";
import ButtonIntroWide from "../../../ui/buttons/ButtonIntroWide";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import * as tutorialUtils from "../../../../abstract/controller/utils/tutorialUtils";
import styles from "./Manual.module.scss";

const id = "dNT5";
const idNext = "dNT6";
const idPrev = "dNT4";

const next = `
functions:
  - function: Demo
    parameters:
      - parameter: Exclusion_Service
        choices:
          - choice: AllGames
          - choice: AllLottery
          - choice: AllSports
          - choice: Lotto
          - choice: Vikinglotto
          - choice: Eurojackpot
          - choice: Extra
          - choice: Joker
          - choice: Keno
          - choice: Nabolaget
          - choice: Tipping
          - choice: Oddsbomben
      - parameter: Pause_Options
        choices:
          - choice: SpillePause
          - choice: Utestegning
      - output parameter: reminder_lotto
        default value: på
`;

const prev = `
functions:
  - function: Demo
    parameters:
      - parameter: Exclusion_Service
        choices:
          - choice: AllGames
          - choice: Lotto
          - choice: Joker
`;

function ManualDedicatedNorskTipping5({ tutorial, setTutorial }) {
  if (tutorial === id) {
    return <Core setTutorial={setTutorial} />;
  }

  return null;
}

function Core({ setTutorial }) {
  const _dispatch = useDispatch();
  const renderTrigger = useArrowSync();

  const handleShowMe = () => {
    const { model } = importFromYaml(next);
    _dispatch(setRoot(model, 0));
  };

  const handleBack = () => {
    const { model } = importFromYaml(prev);
    _dispatch(setRoot(model, 0));
    setTutorial(idPrev);
  };

  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      {document.getElementById("add_output_parameter") && (
        <div className={`${styles["container"]} ${styles["container-dnt5"]} ${styles["overlay"]}`}>
          <div id="tutorial-text-2" className={`${styles["container__text"]}`}>
            <p>
              Click here to add an output parameter and name it <b>reminder_lotto</b>.
            </p>
          </div>

          <Xarrow
            key={`arrow-3-${renderTrigger}`}
            start="tutorial-text-2"
            end="add_output_parameter"
            color="#415B32"
            strokeWidth={2}
            path="smooth"
            curveness={0.8}
            headSize={6}
          />
        </div>
      )}

      <div className={`${styles["foreground"]} ${styles["foreground-dnt5"]}  ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>
              Now, let's add some output parameters. They represent the expected result of a test
              and don’t contain choices. Instead, they can be assigned custom values through
              assignment expressions.
            </p>
            <p>
              In our case, let's create a parameter that informs us that the Lotto reminder is
              active (av). By default, it's mostly inactive, and therefore it makes sense to set
              accordingly the value (på).
            </p>
            <p>
              Click on the <b>ADD OUTPUT PARAMETER</b> button and create one. Name it{" "}
              <b>reminder_lotto</b>. The default value should be <b>på</b>.
            </p>
          </div>
        </div>
        <div className={styles["confirmation"]}>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="red" title="Go back!" onClick={handleBack} />
          </div>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="tomato" title="Show me!" onClick={handleShowMe} />
          </div>
        </div>
      </div>
    </>
  );
}

export const manualValidateDedicatedNorskTipping5 = (root, tutorial, setTutorial, setMessage) => {
  if (tutorial === id) {
    let { res: resFun, msg: msgFun } = tutorialUtils.validateSingleFunction(root);

    if (!resFun) {
      setMessage(msgFun)
      return false;
    }

    let { res: resA, msg: msgA } = tutorialUtils.validateParametersOutput(root, false, ["reminder_lotto"]);

    if (!resA) {
      setMessage(msgA)
      return false;
    }

    let { res: resB, msg: msgB } = tutorialUtils.validateOutputParameterValues(root, "reminder_lotto", "på");

    if (!resB) {
      setMessage(msgB)
      return false;
    }

    setTutorial(idNext);

    setMessage("")
    return true;
  }

  return false;
};

export default ManualDedicatedNorskTipping5;
